        <!-- CONTENT CARD -->
        <div class="content-card" >

            <!-- CONTENT TOOLBAR
            <div class="toolbar px-24 py-8" fxFlex="100">
                <span>Mediciones</span>
            </div>
            <!-- / CONTENT TOOLBAR -->

            <!-- CONTENT -->

            <div class="content" >

                <mat-tab-group dynamicHeight>

                    <mat-tab label="Mediciones">

                        <div class="widget-group p-12" fxLayout="column" fxFlex="100" *fuseIfOnDom>

                            <div fxLayout="row"  fxFlex="100" *ngIf="tieneEditar && action!='View' && kri?.evaluacion?.estado=='APROBADO' ">
                              <div fxLayout="column" fxFlex>
                                  <div fxFlex>
                                    <mat-form-field color="accent" appearance="fill" fxFlex="50">
                                      <mat-label>Fecha</mat-label>
                                      <input matInput [matDatepicker]="picker1" [min]="kri.fechaInicio" [max]="hoy"
                                      [formControl]="fecha">
                                      <!--[(ngModel)]="new_line_p.fecha">-->
                                      <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                      <mat-datepicker #picker1 ></mat-datepicker>
                                    </mat-form-field>
                                    <mat-form-field  fxFlex="50">
                                      <input placeholder="Valor" matInput [(ngModel)]="new_line_p.valor"
                                      onkeypress="return event.charCode >= 48 || event.charCode == 46"
                                      type="number" value="" min="0.01"  pattern="[0-9]+([\.][0-9]+)?" step="any">
                                    </mat-form-field>
                                  </div>
                                </div>
                                <div fxFlex="20">
                                  <button mat-button (click)="addLine()" mat-flat-button color="primary" class="add-row">{{buttonAction}}</button>
                                </div>
                              </div>

                              <div class="content p-24" fxFlex="100">

                                  <table mat-table [dataSource]="kri.mediciones" #mytable class="my-table mat-elevation-z8" fxFlex="100">

                                    <!-- User Column -->
                                    <ng-container matColumnDef="fecha">
                                      <th mat-header-cell *matHeaderCellDef> Fecha </th>
                                      <td mat-cell *matCellDef="let element"> {{element.fecha | date:'dd/MM/yyyy'}} </td>
                                    </ng-container>

                                    <ng-container matColumnDef="valor">
                                      <th mat-header-cell *matHeaderCellDef> Valor</th>
                                      <td mat-cell *matCellDef="let element"> {{element.valor}} </td>
                                    </ng-container>

                                    <!-- Action Column -->
                                    <ng-container matColumnDef="action">
                                      <th mat-header-cell *matHeaderCellDef> Acción </th>
                                      <td mat-cell *matCellDef="let element" class="action-link">
                                        <a (click)="edit(element)" *ngIf="tieneEditar && action!='View'">Modificar</a>
                                        <span *ngIf="tieneEditar && action!='View'"> | </span>
                                        <a (click)="remove(element)" *ngIf="tieneEditar && action!='View'">Eliminar</a>
                                      </td>
                                    </ng-container>

                                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                                  </table>

                              </div>
                            </div>
                        </mat-tab>
                        <mat-tab label="Gráficas">
                            <div class="widget-group p-12" fxLayout="column wrap" fxFlex="100" *fuseIfOnDom>

                              <mat-tab-group dynamicHeight>

                                  <mat-tab label="Evolución">
                                      <div class="flex-container" fxFlex="100">
                                          <mat-card class="chart-card" fxFlex="100">
                                              <mat-card-title>
                                              </mat-card-title>
                                              <mat-card-content>
                                                <ngx-charts-bar-vertical
                                                fxFlex="100"
                                                [results]="chartDataKrisSingle"
                                                [scheme]="colorScheme"
                                                [legend]="legend"
                                                [showXAxisLabel]="showXAxisLabel"
                                                [showYAxisLabel]="showYAxisLabel"
                                                [xAxis]="xAxis"
                                                [yAxis]="yAxis"
                                                [xAxisLabel]="xAxisLabel"
                                                [yAxisLabel]="yAxisLabel"
                                                >
                                                </ngx-charts-bar-vertical>
                                              </mat-card-content>
                                          </mat-card>
                                      </div>
                                  </mat-tab>
                                  <mat-tab label="Linea de tiempo">

                                      <div class="flex-container" fxFlex="100">
                                          <mat-card class="chart-card" fxFlex="100">
                                              <mat-card-title>

                                              </mat-card-title>
                                              <mat-card-content>
                                                <ngx-charts-line-chart
                                                  fxFlex="100"
                                                  [scheme]="colorScheme"
                                                  [legend]="legend"
                                                  [showXAxisLabel]="showXAxisLabel"
                                                  [showYAxisLabel]="showYAxisLabel"
                                                  [xAxis]="xAxis"
                                                  [yAxis]="yAxis"
                                                  [xAxisLabel]="xAxisLabel"
                                                  [yAxisLabel]="yAxisLabel"
                                                  [timeline]="timeline"
                                                  [results]="chartDataKris"
                                                  >
                                                </ngx-charts-line-chart>
                                              </mat-card-content>
                                          </mat-card>
                                      </div>
                                    </mat-tab>
                                    <mat-tab label="Por medición">

                                      <div class="flex-container" fxFlex="100">
                                          <mat-card class="chart-card" fxFlex="100">
                                              <mat-card-title>
                                              </mat-card-title>
                                              <mat-card-content>
                                                <ngx-charts-pie-grid
                                                  fxFlex="100"
                                                  [scheme]="colorScheme"
                                                  [results]="pieDataKris"
                                                  >
                                                </ngx-charts-pie-grid>
                                              </mat-card-content>
                                          </mat-card>
                                      </div>
                                    </mat-tab>
                                  </mat-tab-group>
                            </div>
                        </mat-tab>
                        <!--<mat-tab label="Evolución">
                            <div class="widget-group p-12" fxLayout="column wrap" fxFlex="100" *fuseIfOnDom>
                            </div>
                        </mat-tab>-->
                    </mat-tab-group>
            </div>
            <!-- / CONTENT -->

        </div>
        <!-- / CONTENT CARD -->
